export function getSafeHttpUrl(url: unknown): string {
  const value = String(url ?? '').trim();
  if (!value) {
    return '';
  }
  try {
    const parsed = new URL(value, window.location.origin);
    if (!['http:', 'https:'].includes(parsed.protocol)) {
      return '';
    }
    return parsed.href;
  } catch {
    return '';
  }
}

export function openSafeHttpUrl(url: unknown): void {
  const safeUrl = getSafeHttpUrl(url);
  if (safeUrl) {
    window.open(safeUrl, '_blank', 'noopener,noreferrer');
  }
}
